import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Embalagem',
  path: '/merenda/merembalagem',
  name: 'merembalagem',
  component: () => import('@/views/merenda/merembalagem/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.EMBALAGEMNOVO_MENU_1000600499],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Embalagem',
  path: '/merenda/merembalagem/cadastro/:id?',
  parent: 'merembalagem',
  name: 'merembalagem_create',
  component: () => import('@/views/merenda/merembalagem/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.EMBALAGEMNOVO_MENU_1000600499],
  },
  goesToMenu: true,
 },
]
